<div class="row">
    <div class="col">
      <button class='btn btn-info' (click)='newOrder()'>New Order</button>
    </div>
  </div>
  
  <div class="bg-primary pb-3">
    <app-grid
      entity='price-list'
      [filters]='this.filters'
      [columns]='this.columns'
      [buttons]='this.buttons'
      [searchFilters]='this.searchFilters'
      [searchFields]='this.searchFields'
  ></app-grid>
  </div>
  